import { render, staticRenderFns } from "./showAchievement.vue?vue&type=template&id=00abd936&scoped=true"
import script from "./showAchievement.vue?vue&type=script&lang=js"
export * from "./showAchievement.vue?vue&type=script&lang=js"
import style0 from "./showAchievement.vue?vue&type=style&index=0&id=00abd936&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00abd936",
  null
  
)

export default component.exports